import { render, staticRenderFns } from "./EmployeeTabBar.vue?vue&type=template&id=fa320f5e"
import script from "./EmployeeTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeTabBar.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports